import React from 'react';

import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import { Stack,} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import {Handle, Position} from "reactflow";
import Chip from "@mui/joy/Chip";

// icons
import AttachFileIcon from "@mui/icons-material/AttachFile";
import BrightnessHighIcon from "@mui/icons-material/BrightnessHigh";


class RouteSimpleNode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stage: props.data.obj,
        };
    }

    render() {
        return (
            <Card
                variant={'solid'}
                color={this.state.stage.next_stages.length===0?'success':this.state.stage.first?'warning':null}
                sx={{
                    width: 300
                }}
                size={'sm'}
            >
                <CardContent>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Typography level="body-md">
                            <Chip
                                color={this.state.stage.color}
                                sx={{
                                    mr: 1
                                }}
                            >
                                {this.state.stage.title}
                            </Chip>
                        </Typography>
                        <BrightnessHighIcon
                            color={'warning'}
                            onClick={
                                () => (this.props.data.highlightCallBack(this.props.data.obj.id))
                            }
                            sx={{
                                cursor: 'pointer'
                            }}
                        />
                    </Stack>
                    <Chip
                        color={'primary'}
                        sx={{
                            mr: 1
                        }}
                    >
                        {this.state.stage.operator.title}
                    </Chip>
                    {
                        this.state.stage.is_attach_needed?
                            <Chip
                                color={'warning'}
                                sx={{
                                    mr: 1
                                }}
                                startDecorator={<AttachFileIcon fontSize={'small'}/>}
                            >
                                Требуется вложение
                            </Chip> :
                            null
                    }
                    {
                        this.state.stage.is_note_needed?
                            <Chip
                                color={'warning'}
                                sx={{
                                    mr: 1
                                }}
                            >
                                Требуется комментарий
                            </Chip> :
                            null
                    }
                    <Typography>Срок: {this.state.stage.end_delay} дн.</Typography>
                </CardContent>
                <Handle
                    type="target"
                    isConnectable={this.props.isConnectable}
                    position={Position.Left}
                    style={{
                        background: "green",
                        width: 10,
                        height: 10,
                    }}
                />
                <Handle
                    type="source"
                    isConnectable={this.props.isConnectable}
                    position={Position.Right}
                    style={{
                        background: "red",
                        width: 10,
                        height: 10,
                    }}
                />
            </Card>
        )
    }
}

export default RouteSimpleNode;
